import React, { useState } from "react";
import { auth, db } from "../../firebase/config";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { collection, addDoc, doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

export default function Registro() {
  const [paso, setPaso] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [datos, setDatos] = useState({
    nombreClinica: "",
    cantidadMedicos: 1,
    cantidadRecepcionistas: 1,
    cantidadAdministrativos: 0,
    email: "",
    password: "",
    confirmarPassword: "",
  });

  function planRecomendado() {
    const total = parseInt(datos.cantidadMedicos) + parseInt(datos.cantidadRecepcionistas) + parseInt(datos.cantidadAdministrativos);
    if (total <= 3) return { plan: 'starter', label: 'Starter', color: '#AEB6C4', descripcion: 'Ideal para consultorios pequeños' };
    if (total <= 6) return { plan: 'advanced', label: 'Advanced', color: '#00B8FF', descripcion: 'Ideal para clínicas en crecimiento' };
    return { plan: 'pro', label: 'Pro', color: '#B478FF', descripcion: 'Ideal para clínicas grandes' };
  }

  async function handleRegistro() {
    if (datos.password !== datos.confirmarPassword) {
      setError("Las contraseñas no coinciden");
      return;
    }
    if (datos.password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres");
      return;
    }
    setError("");
    setLoading(true);

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, datos.email, datos.password);
      const user = userCredential.user;

      const clinicaRef = await addDoc(collection(db, 'clinicas'), {
        nombre: datos.nombreClinica,
        email: datos.email,
        plan: planRecomendado().plan,
        estado: 'pendiente_activacion',
        cantidadMedicos: parseInt(datos.cantidadMedicos),
        cantidadRecepcionistas: parseInt(datos.cantidadRecepcionistas),
        cantidadAdministrativos: parseInt(datos.cantidadAdministrativos),
        creadoEn: new Date(),
      });

      await setDoc(doc(db, 'usuarios', user.uid), {
        email: datos.email,
        rol: 'gestion_general',
        clinicaId: clinicaRef.id,
        nombre: datos.nombreClinica,
        activo: true,
        creadoEn: new Date(),
      });
      await fetch('https://us-central1-deluxe-software.cloudfunctions.net/notificarRegistro', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nombreClinica: datos.nombreClinica, email: datos.email, plan: planRecomendado().plan })
      }).catch(() => {});
      

      if (typeof window.gtag === "function") {
        window.gtag("event", "registro_completado", {
          plan: planRecomendado().plan,
          nombreClinica: datos.nombreClinica
        });
      }
  // Evento Meta Píxel — registro exitoso
       if (typeof window.fbq === "function") {
        window.fbq("track", "CompleteRegistration");
      }


      setPaso(3);
    } catch (err) {
      if (err.code === 'auth/email-already-in-use') {
        setError("Este correo ya está registrado");
      } else {
        setError("Error al registrar: " + err.message);
      }
    }
    setLoading(false);
  }

  const inputStyle = {
    width: '100%', padding: '12px 16px', fontSize: '14px',
    border: '0.5px solid rgba(174, 182, 196, 0.3)',
    borderRadius: '8px', outline: 'none',
    color: '#F3F5F7', background: 'rgba(2, 11, 31, 0.6)',
    boxSizing: 'border-box', fontFamily: "'Montserrat', sans-serif"
  };

  const labelStyle = {
    fontSize: '11px', color: '#AEB6C4', display: 'block',
    marginBottom: '6px', fontWeight: '500', letterSpacing: '1px'
  };

  const recomendacion = planRecomendado();

  return (
    <div style={{
      minHeight: "100vh", background: "#020B1F",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "'Montserrat', sans-serif", padding: '24px'
    }}>
      <div style={{
        background: "rgba(39, 55, 80, 0.4)", borderRadius: "16px",
        padding: "48px 40px", width: "100%", maxWidth: "480px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
        border: "0.5px solid rgba(174, 182, 196, 0.2)"
      }}>

        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <img src="/Logotipo-Deluxe.png" alt="Deluxe Software" style={{ height: "110px", width: "auto" }} />
          <div style={{ fontSize: "12px", color: "#AEB6C4", letterSpacing: "2px", marginTop: "12px" }}>
            GESTIÓN MÉDICA AVANZADA
          </div>
        </div>

        {paso < 3 && (
          <div style={{ display: 'flex', gap: '8px', marginBottom: '32px' }}>
            {[1, 2].map(p => (
              <div key={p} style={{
                flex: 1, height: '3px', borderRadius: '99px',
                background: paso >= p ? '#00B8FF' : 'rgba(174,182,196,0.2)'
              }} />
            ))}
          </div>
        )}

        {paso === 1 && (
          <div>
            <div style={{ fontSize: '18px', fontWeight: '600', color: '#F3F5F7', marginBottom: '6px' }}>
              Datos de tu clínica
            </div>
            <div style={{ fontSize: '13px', color: '#AEB6C4', marginBottom: '24px' }}>
              Contanos sobre tu equipo para recomendarte el plan ideal
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label style={labelStyle}>NOMBRE DE LA CLÍNICA O MÉDICO</label>
                <input
                  value={datos.nombreClinica}
                  onChange={e => setDatos({ ...datos, nombreClinica: e.target.value })}
                  placeholder="Dr. García / Clínica Visión"
                  style={inputStyle}
                />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={labelStyle}>MÉDICOS</label>
                  <select value={datos.cantidadMedicos} onChange={e => setDatos({ ...datos, cantidadMedicos: e.target.value })} style={inputStyle}>
                    {[0,1,2,3,4,5,6,7,8,9,10].map(n => <option key={n} value={n}>{n}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>RECEPCIÓN</label>
                  <select value={datos.cantidadRecepcionistas} onChange={e => setDatos({ ...datos, cantidadRecepcionistas: e.target.value })} style={inputStyle}>
                    {[0,1,2,3,4,5].map(n => <option key={n} value={n}>{n}</option>)}
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>ADMIN</label>
                  <select value={datos.cantidadAdministrativos} onChange={e => setDatos({ ...datos, cantidadAdministrativos: e.target.value })} style={inputStyle}>
                    {[0,1,2,3,4,5].map(n => <option key={n} value={n}>{n}</option>)}
                  </select>
                </div>
              </div>

              <div style={{
                padding: '14px 16px', borderRadius: '10px',
                background: 'rgba(0,184,255,0.08)',
                border: `0.5px solid ${recomendacion.color}40`
              }}>
                <div style={{ fontSize: '11px', color: '#AEB6C4', marginBottom: '4px', letterSpacing: '1px' }}>PLAN RECOMENDADO</div>
                <div style={{ fontSize: '16px', fontWeight: '700', color: recomendacion.color, textTransform: 'uppercase' }}>
                  {recomendacion.label}
                </div>
                <div style={{ fontSize: '12px', color: '#AEB6C4', marginTop: '2px' }}>{recomendacion.descripcion}</div>
              </div>
            </div>

            <button
              onClick={() => {
                if (!datos.nombreClinica) { setError("Ingresá el nombre de tu clínica"); return; }
                setError("");
                setPaso(2);
              }}
              style={{
                width: '100%', padding: '13px', fontSize: '13px', fontWeight: '600',
                background: 'linear-gradient(135deg, #00B8FF, #0088CC)',
                color: '#FFFFFF', border: 'none', borderRadius: '8px',
                cursor: 'pointer', marginTop: '24px', letterSpacing: '1px',
                fontFamily: "'Montserrat', sans-serif"
              }}
            >
              CONTINUAR
            </button>
          </div>
        )}

        {paso === 2 && (
          <div>
            <div style={{ fontSize: '18px', fontWeight: '600', color: '#F3F5F7', marginBottom: '6px' }}>
              Creá tu cuenta
            </div>
            <div style={{ fontSize: '13px', color: '#AEB6C4', marginBottom: '24px' }}>
              Vas a usar este correo para ingresar al sistema
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label style={labelStyle}>CORREO ELECTRÓNICO</label>
                <input
                  type="email"
                  value={datos.email}
                  onChange={e => setDatos({ ...datos, email: e.target.value })}
                  placeholder="admin@tuclinica.com"
                  style={inputStyle}
                />
              </div>
              <div>
                <label style={labelStyle}>CONTRASEÑA</label>
                <input
                  type="password"
                  value={datos.password}
                  onChange={e => setDatos({ ...datos, password: e.target.value })}
                  placeholder="Mínimo 6 caracteres"
                  style={inputStyle}
                />
              </div>
              <div>
                <label style={labelStyle}>CONFIRMAR CONTRASEÑA</label>
                <input
                  type="password"
                  value={datos.confirmarPassword}
                  onChange={e => setDatos({ ...datos, confirmarPassword: e.target.value })}
                  placeholder="Repetí la contraseña"
                  style={inputStyle}
                />
              </div>
            </div>

            {error && (
              <div style={{
                background: "rgba(255, 59, 48, 0.15)", color: "#FF6B6B",
                fontSize: "13px", padding: "10px 14px", borderRadius: "8px",
                marginTop: "16px", border: "0.5px solid rgba(255, 59, 48, 0.3)"
              }}>
                {error}
              </div>
            )}

            <div style={{ display: 'flex', gap: '8px', marginTop: '24px' }}>
              <button onClick={() => setPaso(1)} style={{
                flex: 1, padding: '13px', fontSize: '13px',
                background: 'transparent', border: '0.5px solid rgba(174,182,196,0.3)',
                borderRadius: '8px', color: '#AEB6C4', cursor: 'pointer',
                fontFamily: "'Montserrat', sans-serif"
              }}>
                Atrás
              </button>
              <button onClick={handleRegistro} disabled={loading} style={{
                flex: 2, padding: '13px', fontSize: '13px', fontWeight: '600',
                background: loading ? '#273750' : 'linear-gradient(135deg, #00B8FF, #0088CC)',
                color: '#FFFFFF', border: 'none', borderRadius: '8px',
                cursor: loading ? 'not-allowed' : 'pointer', letterSpacing: '1px',
                fontFamily: "'Montserrat', sans-serif"
              }}>
                {loading ? "REGISTRANDO..." : "CREAR CUENTA"}
              </button>
            </div>
          </div>
        )}

        {paso === 3 && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
            <div style={{ fontSize: '20px', fontWeight: '700', color: '#F3F5F7', marginBottom: '8px' }}>
              ¡Registro completado!
            </div>
            <div style={{ fontSize: '14px', color: '#AEB6C4', marginBottom: '8px', lineHeight: '1.6' }}>
              Tu cuenta fue creada exitosamente. En menos de 24 horas vas a recibir un correo con el acceso a tu período de prueba gratuito de 30 días.
            </div>
            <div style={{ fontSize: '13px', color: '#00B8FF', marginBottom: '32px' }}>
              {datos.email}
            </div>
            <button onClick={() => navigate("/")} style={{
              width: '100%', padding: '13px', fontSize: '13px', fontWeight: '600',
              background: 'linear-gradient(135deg, #00B8FF, #0088CC)',
              color: '#FFFFFF', border: 'none', borderRadius: '8px',
              cursor: 'pointer', fontFamily: "'Montserrat', sans-serif"
            }}>
              IR AL LOGIN
            </button>
          </div>
        )}

        {paso < 3 && (
          <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '12px', color: 'rgba(174,182,196,0.5)' }}>
            ¿Ya tenés cuenta? <span onClick={() => navigate("/")} style={{ color: '#00B8FF', cursor: 'pointer' }}>Ingresá acá</span>
          </div>
        )}

      </div>
    </div>
  );
}